import { z } from 'zod';
import { NoteCategorySchema } from './note-category.schema';
import { NoteGeometrySchema } from './note-geometry.schema';
import { NoteTargetsSchema } from './note-targets.schema';
/**
 * Live/published sticky note (`processnotes`), the read-model twin of
 * `ProcessDraftNote`. Materialised on publish and rendered read-only in the
 * process flow viewer and analyzer. `targets` reference live recordings by the
 * `stableStepId` carried over from the draft.
 */ export const ProcessNoteSchema = z.object({
    _id: z.string(),
    process: z.string(),
    text: z.string(),
    category: NoteCategorySchema,
    geometry: NoteGeometrySchema,
    targets: NoteTargetsSchema,
    // Nullable: a hard-deleted author (delete-tenant-user) leaves a dangling ref,
    // mirroring the recordedBy-null guard on recordings.
    createdBy: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string()
});

//# sourceMappingURL=process-note.schema.js.map